module.exports = __webpack_public_path__ + "img/icon3.8b61a88e.svg";